<script>
	import DBLayer from './components/DatabaseLayer.svelte';
	import DataLayer from './components/DataLayer.svelte';
	import Introduction from './components/Introduction.svelte';
	import Map from './components/Map.svelte';
	import StopTimeline from './components/StopTimeline.svelte';
</script>

<!-- The DBLayer exposes a query function in their context -->
<DBLayer let:key={databaseKey}>
	<!-- So all components within it can access the database -->
	<!-- The Datalayer retrieves and puts the main state & data in a contxt -->
	<DataLayer let:key={dataKey} {databaseKey}>
		<div class="row">
			<Introduction {dataKey} />
			<div class="col">
				<Map {dataKey} />
				<StopTimeline {dataKey} />
			</div>
		</div>
	</DataLayer>
</DBLayer>

<style>
	:global(.row) {
		display: flex;
		flex-direction: row;
	}
	:global(.col) {
		display: flex;
		flex-direction: column;
	}
	:global(.card) {
		margin: 5px;
		padding: 5px;
		border-radius: 5px;
		border-style: solid;
		border-color: #ddd;
		border-width: 1px;
	}
	:global(.no-select) {
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}
</style>
